export default __webpack_public_path__ + "static/paranavai-32fcae87308a328712fd0c11bddeb200.png";